import React from 'react'
import { Icon, IconProps } from './Icon'

export function ChevronDown(props: Omit<IconProps, 'children'>) {
  return (
    <Icon {...props}>
      <path d="m6 9 6 6 6-6"/>
    </Icon>
  )
}
